import React from 'react';
import { Stack, NavLink } from '@mantine/core';
import { IconHome } from '@tabler/icons-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { NONPROFIT_ROUTES } from '../../routing/routes';

/**
 * NonProfitNavbar Component
 *
 * Navigation sidebar for non-profit users.
 * Sprint 062 Session 7: Initial version with Dashboard link.
 * Future sessions will add Phrases, Mentions, Subscription links.
 */
export const NonProfitNavbar: React.FC = (): React.ReactElement => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path: string): boolean => {
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  const handleNavigate = (path: string): void => {
    navigate(path);
  };

  return (
    <Stack gap="xs" p="md">
      <NavLink
        label="Dashboard"
        leftSection={<IconHome size={20} stroke={1.5} />}
        active={isActive(NONPROFIT_ROUTES.DASHBOARD)}
        onClick={(): void => handleNavigate(NONPROFIT_ROUTES.DASHBOARD)}
        variant="subtle"
      />
    </Stack>
  );
};
